import {
    actionSetFragment,
    materialPriceDifferenceFragment,
    priceListFragment,
    actionMaterialGroupFragment,
} from 'apollo/fragments';
import { gql } from 'graphql.macro';

export const getActionSetsTemplate = gql`
    query actionSets {
        actionSets {
            _id
            title
        }
    }
`;

export const getActionSetTemplate = gql`
    query actionSet($actionSetId: MongoDbObjectId!, $orgId: MongoDbObjectId!, $labId: MongoDbObjectId) {
        actionSet(actionSetId: $actionSetId, orgId: $orgId, labId: $labId) {
            ...actionSet
        }
    }
    ${actionSetFragment}
`;
